import {
    CalendarIcon,
    ChevronDoubleDownIcon,
    ChevronDoubleUpIcon,
    ClipboardDocumentIcon,
    LockClosedIcon,
} from "@heroicons/react/24/outline";
import { Menu, Transition } from "@headlessui/react";
import { useRef, useState } from "react";
import { ConfirmDialog } from "./AppointmentConfirmDialog";
import { MenuWithPortal } from "./MenuWithPortal";
import api from "../../../api";
import { getLocalDateString } from "../../../util/formatDate";

export const AppointmentTable = ({
    data,
    onRowClick,
    loading,
    notify,
    onSave,
}) => {
    const [expandedRow, setExpandedRow] = useState(null);
    const [menuPosition, setMenuPosition] = useState({
        top: 0,
        left: 0,
        openUp: false,
    });
    // const [selectedAppointment, setSelectedAppointment] = useState(null);
    // const dialogRef = useRef(null);
    // const visibleData = data.filter((appt) => appt.status !== 5);
    const dataLength = data.length;
    const statusList = [
        "Pendiente",
        "Recordatorio enviado",
        "Confirmado",
        "Cancelado",
        "Recibido",
    ];
    const appointmentTypeList = ["Consulta", "Estudio"];
    const statusStyles = [
        "text-yellow-800 bg-yellow-100",
        "text-blue-800 bg-blue-100",
        "text-green-800 bg-green-100",
        "text-red-800 bg-red-100",
        "text-purple-800 bg-purple-100",
    ];
    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const [y, m, d] = dateStr.split("-");
        return `${d}-${m}-${y}`;
    };

    // const openDialog = (appointment) => {
    //     setSelectedAppointment(appointment);
    //     dialogRef.current?.showModal();
    // };

    // const closeDialog = () => {
    //     dialogRef.current?.close();
    //     setSelectedAppointment(null);
    // };

    return (
        <div className="shadow-lg border-b border-gray-200 dark:border-gray-700 overflow-auto">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700  text-sm">
                <thead className="bg-gray-50 dark:bg-gray-900">
                    <tr>
                        <th className="w-28 px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                            Fecha
                        </th>
                        <th className="w-20 px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                            Hora
                        </th>
                        <th className="min-w-[220px] max-w-[300px] px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                            Paciente
                        </th>
                        <th className="min-w-[150px] max-w-[200px] px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                            Doctor
                        </th>
                        <th className="w-36 px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                            Estado
                        </th>
                        <th className="w-24 px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                            Tipo
                        </th>
                        <th className="w-10"></th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-300 dark:divide-gray-600">
                    {loading ? (
                        <tr>
                            <td
                                colSpan={5}
                                className="px-6 py-8 text-center text-gray-500 dark:text-gray-400"
                            >
                                <div className="flex items-center justify-center space-x-2">
                                    <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                </div>
                            </td>
                        </tr>
                    ) : data.length === 0 ? (
                        <tr>
                            <td
                                colSpan={7} // número de columnas de tu tabla
                                className="px-6 py-4 text-center text-gray-500 dark:text-gray-400"
                            >
                                No hay citas disponibles
                            </td>
                        </tr>
                    ) : (
                        data.map(
                            (appt, idx) =>
                                appt.patient && (
                                    <>
                                        <tr
                                            key={appt.id}
                                            className={`${
                                                appt.patient.hasConsultations
                                                    ? "bg-blue-100 dark:bg-blue-900/40"
                                                    : "bg-gray-100 dark:bg-gray-800/60"
                                            }`}
                                        >
                                            <td className="w-28 px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-200">
                                                {formatDate(appt.date)}
                                            </td>
                                            <td className="max-w-20 px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-200">
                                                {appt.time
                                                    ? appt.time
                                                          .split(":")
                                                          .slice(0, 2)
                                                          .join(":")
                                                    : "Sin agendamiento"}
                                            </td>
                                            <td
                                                className={`whitespace-nowrap min-w-[220px] max-w-[300px] text-sm text-gray-700 dark:text-gray-200 ${
                                                    appt.patient
                                                        .hasConsultations
                                                        ? "hover:bg-blue-200 dark:hover:bg-blue-900"
                                                        : "hover:bg-gray-200 dark:hover:bg-gray-700"
                                                } transition-colors cursor-pointer pointer`}
                                            >
                                                <Menu
                                                    as="div"
                                                    className="relative inline-block text-left w-full"
                                                >
                                                    <Menu.Button
                                                        className="inline-flex w-full justify-start px-3 py-2 text-sm text-black dark:text-white"
                                                        onClick={(e) => {
                                                            const rect =
                                                                e.currentTarget.getBoundingClientRect();
                                                            const isLastFive =
                                                                idx >=
                                                                dataLength - 5;
                                                            setMenuPosition({
                                                                top:
                                                                    rect.bottom +
                                                                    window.scrollY,
                                                                left:
                                                                    rect.left +
                                                                    window.scrollX,
                                                                openUp: isLastFive,
                                                                bottom:
                                                                    rect.top +
                                                                    window.scrollY,
                                                            });
                                                        }}
                                                    >
                                                        <span
                                                            className={`truncate block max-w-full overflow-hidden text-ellipsis whitespace-nowrap`}
                                                            title={
                                                                appt.patient
                                                                    ? `${appt.patient.firstName} ${appt.patient.lastName} (${appt.patient.insuranceNames?.length ? appt.patient.insuranceNames.join(", ") : "---"})`
                                                                    : "-"
                                                            }
                                                        >
                                                            {appt.patient
                                                                ? `${appt.patient.firstName} ${appt.patient.lastName} (${appt.patient.insuranceNames?.length ? appt.patient.insuranceNames.join(", ") : "---"})`
                                                                : "-"}
                                                        </span>
                                                    </Menu.Button>

                                                    <Transition>
                                                        <MenuWithPortal>
                                                            <Menu.Items
                                                                className="absolute z-50 w-56 rounded-md bg-white dark:bg-gray-900 shadow-lg ring-black ring-opacity-5 focus:outline-none"
                                                                style={{
                                                                    top: !menuPosition.openUp
                                                                        ? menuPosition.top
                                                                        : undefined,
                                                                    left: menuPosition.left,
                                                                    bottom: menuPosition.openUp
                                                                        ? window.innerHeight -
                                                                          menuPosition.bottom
                                                                        : undefined,
                                                                }}
                                                            >
                                                                <LocalMenu
                                                                    data={appt}
                                                                    onRowClick={
                                                                        onRowClick
                                                                    }
                                                                    appt={appt}
                                                                    notify={
                                                                        notify
                                                                    }
                                                                    onSave={
                                                                        onSave
                                                                    }
                                                                />
                                                            </Menu.Items>
                                                        </MenuWithPortal>
                                                    </Transition>
                                                </Menu>
                                            </td>
                                            <td
                                                className="min-w-[150px] max-w-[200px] px-6 py-4 whitespace-nowrap text-sm"
                                                title={`${appt.doctor.firstName} ${appt.doctor.lastName}`}
                                            >
                                                <span className="max-w-[200px] inline-block bg-gray-100 text-gray-800 px-2 py-1 rounded-full font-semibold truncate">
                                                    {`${appt.doctor.firstName} ${appt.doctor.lastName}`}
                                                </span>
                                            </td>
                                            <td
                                                // onClick={(e) => {
                                                //     if(appt.status < 3 ){
                                                //         e.stopPropagation();
                                                //         openDialog(appt);
                                                //     }
                                                // }}
                                                className={`w-36 px-6 py-4 whitespace-nowrap text-sm transition-colors cursor-pointer ${
                                                    appt.patient
                                                        .hasConsultations
                                                        ? "hover:bg-blue-200 dark:hover:bg-blue-800"
                                                        : "hover:bg-gray-200 dark:hover:bg-gray-700"
                                                }`}
                                            >
                                                <Menu
                                                    as="div"
                                                    className="relative inline-block text-left w-full"
                                                >
                                                    <Menu.Button
                                                        className="inline-flex w-full justify-start px-3 py-2 text-sm text-black dark:text-white"
                                                        onClick={(e) => {
                                                            const rect =
                                                                e.currentTarget.getBoundingClientRect();
                                                            const isLastThree =
                                                                idx >=
                                                                dataLength - 3;
                                                            setMenuPosition({
                                                                top:
                                                                    rect.bottom +
                                                                    window.scrollY,
                                                                left:
                                                                    rect.left +
                                                                    window.scrollX,
                                                                openUp: isLastThree,
                                                                bottom:
                                                                    rect.top +
                                                                    window.scrollY,
                                                            });
                                                        }}
                                                    >
                                                        <span
                                                            className={`inline-block px-2 py-1 rounded-full font-semibold ${
                                                                statusStyles[
                                                                    appt.status -
                                                                        1
                                                                ]
                                                            }`}
                                                        >
                                                            {
                                                                statusList[
                                                                    appt.status -
                                                                        1
                                                                ]
                                                            }
                                                        </span>
                                                    </Menu.Button>

                                                    <Transition>
                                                        <MenuWithPortal>
                                                            <Menu.Items
                                                                className="absolute z-50 w-56 rounded-md bg-white dark:bg-gray-900 shadow-lg ring-black ring-opacity-5 focus:outline-none"
                                                                style={{
                                                                    top: !menuPosition.openUp
                                                                        ? menuPosition.top
                                                                        : undefined,
                                                                    left: menuPosition.left,
                                                                    bottom: menuPosition.openUp
                                                                        ? window.innerHeight -
                                                                          menuPosition.bottom
                                                                        : undefined,
                                                                }}
                                                            >
                                                                <StatusMenu
                                                                    appt={appt}
                                                                    notify={
                                                                        notify
                                                                    }
                                                                    onSave={
                                                                        onSave
                                                                    }
                                                                />
                                                            </Menu.Items>
                                                        </MenuWithPortal>
                                                    </Transition>
                                                </Menu>
                                            </td>
                                            <td className="w-24 x-6 py-4 whitespace-nowrap text-sm">
                                                <span className="inline-block bg-gray-100 text-gray-800 px-2 py-1 rounded-full font-semibold">
                                                    {
                                                        appointmentTypeList[
                                                            appt.appointmentType -
                                                                1
                                                        ]
                                                    }
                                                </span>
                                            </td>
                                            <td
                                                className="px-6 py-4 text-sm border-l border-gray-200 dark:border-gray-700 text-gray-400 cursor-pointer"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setExpandedRow(
                                                        expandedRow === appt.id
                                                            ? null
                                                            : appt.id
                                                    );
                                                }}
                                            >
                                                <div className=" w-full h-full flex justify-center items-center">
                                                    {expandedRow === appt.id ? (
                                                        <ChevronDoubleUpIcon className="h-6 w-6" />
                                                    ) : (
                                                        <ChevronDoubleDownIcon className="h-6 w-6" />
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        {expandedRow === appt.id && (
                                            <tr
                                                className={`${
                                                    appt.patient
                                                        .hasConsultations
                                                        ? "bg-blue-100 dark:bg-blue-900/40"
                                                        : "bg-gray-100 dark:bg-gray-800/60"
                                                }`}
                                            >
                                                <td
                                                    colSpan={7}
                                                    className="px-6 py-3"
                                                >
                                                    <div className="flex gap-2 text-sm text-gray-600 dark:text-gray-300">
                                                        <strong>Notas:</strong>{" "}
                                                        {appt.notes ? (
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html: appt.notes,
                                                                }}
                                                            />
                                                        ) : (
                                                            "Sin notas"
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                )
                        )
                    )}
                </tbody>
            </table>
            {/* <dialog ref={dialogRef} className=" rounded-lg" closedby="any">
                <ConfirmDialog
                    selectedAppointment={selectedAppointment}
                    formatDate={formatDate}
                    closeDialog={closeDialog}
                    notify={notify}
                    onSave={onSave}
                />
            </dialog> */}
        </div>
    );
};

const LocalMenu = ({ onRowClick, appt, onSave, notify }) => {
    const [isUrgent, setIsUrgent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingMarkMissed, setLoadingMarkMissed] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const dialogRef = useRef(null);
    const formatDate = (date) => {
        const dateObj = new Date(date);
        const fixed = new Date(
            dateObj.getUTCFullYear(),
            dateObj.getUTCMonth(),
            dateObj.getUTCDate()
        );

        const opciones = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
        };
        let fechaFormateada = new Intl.DateTimeFormat("es-ES", opciones).format(
            fixed
        );
        fechaFormateada =
            fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);
        fechaFormateada = fechaFormateada.replace(",", " del");

        return fechaFormateada;
    };

    const handleSubmit = async () => {
        setLoading(true);
        setErrorMessage("");

        try {
            await api.turns.create({
                doctorGovId: appt.doctor.govId,
                patientGovId: appt.patient.govId,
                isUrgent: isUrgent,
            });

            dialogRef.current?.close();
            notify("Turno creado correctamente", "success");

            await api.appointments.update(
                appt.id,
                {
                    ...appt,
                    doctor: appt.doctor.id,
                    patient: appt.patient.id,
                    status: 5,
                },
                true
            );

            onSave();
            notify("Cita actualizada correctamente", "success");
        } catch (error) {
            if (error.code === "serverError") {
                setErrorMessage("Error 500: Error del servidor");
            } else {
                setErrorMessage(error?.message || "Ocurrió un error");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleMarkTurnAsMissed = async () => {
        if (!appt?.id) return;
        setLoadingMarkMissed(true);
        try {
            const res = await api.turns.getMulti(
                "-created_at",
                null,
                null,
                null,
                { appointment: appt.id }
            );
            const turn = res?.results?.[0] ?? res?.[0];
            if (!turn?.id) {
                notify("No se encontró turno asociado a esta cita", "error");
                return;
            }

            await api.turns.update(
                turn.id,
                { missed_appointment: true },
                true
            );

            await api.appointments.update(
                appt.id,
                {
                    status: 4,
                    time: null,
                    unscheduled: true,
                },
                true
            );

            notify("Turno marcado como ausente", "success");
            onSave?.();
        } catch (error) {
            notify("Ocurrió un error al marcar como ausente", "error");
        } finally {
            setLoadingMarkMissed(false);
        }
    };
    const formattedToday = getLocalDateString();
    const turnDisabled = appt?.status === 5 || appt?.status === 4 || appt.date !== formattedToday;
    return (
        <div className="flex flex-col justify-start items-start gap-3 px-3 py-3 text-black dark:text-white">
            <div className="flex-col gap-1">
                <h6 className="text-md font-semibold">
                    {formatDate(appt.date)}
                </h6>
                <small className="text-gray-600 dark:text-gray-400 text-xs">{`${appt.doctor.firstName} ${appt.doctor.lastName}`}</small>
            </div>
            <button
                type="button"
                disabled={appt.id && !appt.patient}
                onClick={() => onRowClick?.(appt)}
                className="px-2 py-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer pointer w-full gap-2 flex justify-start items-center disabled:bg-gray-200 disabled:dark:bg-gray-800 disabled:text-gray-400 disabled:cursor-not-allowed disabled:hover:bg-none"
            >
                <CalendarIcon className="h-6 w-6" />{" "}
                {appt.patient ? "Editar" : "Agendar"}
            </button>
            <button
                type="button"
                className="px-2 py-3 rounded-lg transition-colors w-full gap-2 flex justify-start items-center 
                hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer disabled:bg-gray-200 disabled:dark:bg-gray-800 
                disabled:text-gray-400 disabled:cursor-not-allowed disabled:hover:bg-none"
                onClick={() => dialogRef.current?.showModal()}
                disabled={turnDisabled}
            >
                <ClipboardDocumentIcon className="h-6 w-6" /> Agregar al turnero
            </button>

            <button
                type="button"
                className="px-2 py-3 rounded-lg transition-colors w-full gap-2 flex justify-start items-center 
                hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer disabled:bg-gray-200 disabled:dark:bg-gray-800 
                disabled:text-gray-400 disabled:cursor-not-allowed disabled:hover:bg-none"
                onClick={handleMarkTurnAsMissed}
                disabled={appt?.status !== 5 || loadingMarkMissed}
            >
                <LockClosedIcon className="h-6 w-6" />
                {loadingMarkMissed
                    ? "Cancelando..."
                    : "Cancelar turno"}
            </button>
            <dialog
                ref={dialogRef}
                closedBy="any"
                className="bg-white dark:bg-gray-900 text-black dark:text-white px-12 py-6 rounded-lg shadow-lg"
            >
                <div>
                    <div className="text-center">
                        <h3 className="text-lg leading-6 font-semibold text-gray-900 dark:text-white">
                            Confirmación
                        </h3>
                        <div className="mt-2 w-full">
                            <label
                                htmlFor="password"
                                className="text-sm font-medium text-gray-700 dark:text-gray-400"
                            >
                                ¿Está seguro de que quiere agregar el paciente
                                al turnero?
                            </label>
                            <div className="relative w-2/3 rounded-md mx-auto">
                                {errorMessage &&
                                    Object.keys(errorMessage).map((element) => (
                                        <p className="mt-2 text-sm text-red-600">
                                            {errorMessage[element]}
                                        </p>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                    <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary sm:col-start-2 sm:text-sm disabled:cursor-wait"
                        onClick={() => handleSubmit()}
                        disabled={loading}
                    >
                        {loading ? (
                            <div className="flex items-center justify-center space-x-2">
                                <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                            </div>
                        ) : (
                            "Aceptar"
                        )}
                    </button>
                    <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:col-start-1 sm:text-sm"
                        onClick={() => dialogRef.current?.close()}
                    >
                        Regresar
                    </button>
                </div>
            </dialog>
        </div>
    );
};

const StatusMenu = ({ appt, onSave, notify }) => {
    const [loading, setLoading] = useState();

    const handleUpdate = async (data) => {
        if (!appt.id) return;
        try {
            setLoading(true);
            await api.appointments.update(appt.id, data, true);
            onSave();
            notify("Estado Actualizado", "success");
        } catch (error) {
            notify("Ocurrió un error. Inténtalo de nuevo.", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col justify-start items-start gap-3 px-3 py-3 text-black dark:text-white">
            <button
                type="button"
                disabled={appt?.status === 4 || appt?.status === 5}
                onClick={() =>
                    handleUpdate({ status: 4, time: null, unscheduled: true })
                }
                className="px-8 py-2 rounded text-red-500 border border-red-500 bg-red-100 hover:bg-red-200 transition-all disabled:opacity-50 w-full"
            >
                Cancelar
            </button>
            <button
                type="button"
                className="px-8 py-2 rounded-lg w-full bg-green-100 text-green-700 border border-green-700 font-semibold hover:bg-green-300 transition-all disabled:opacity-50"
                onClick={() => handleUpdate({ status: 3 })}
                disabled={appt?.status === 3 || appt?.status === 5}
            >
                Confirmar
            </button>
        </div>
    );
};
